import type {FunctionComponent, PropsWithChildren} from "react";
import {createContext, useState} from "react";

import type {CommonDataContextProps} from "~/contexts/CommonDataLoadingStatusContext/commonDataContextTypes.ts";


export const CommonDataLoadingStatusContent = createContext<CommonDataContextProps | undefined>(undefined);

export const CommonDataLoadingStatusProvider: FunctionComponent<PropsWithChildren> = ({children}) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);

    return (
        <CommonDataLoadingStatusContent.Provider value={{isLoading, setIsLoading}}>
            {children}
        </CommonDataLoadingStatusContent.Provider>
    );
};
